import { GlobalStyles } from "@mui/material";
import React from "react";

const GlobalStylesComponent = () => (
    <GlobalStyles
        styles={{
            "html, body, #root": {
                height: "100%",
                overflow: "hidden",
                fontFamily: "'Montserrat', sans-serif",
                backgroundColor: "var(--oc-page-bg, #FAF9F6)",
                color: "var(--oc-text, #1a1a1a)",
            },
            /* data-oc-theme set by branding.ts when dark palette is active */
            'html[data-oc-theme="dark"] body, html[data-oc-theme="dark"] #root': {
                backgroundColor: "var(--oc-page-bg, #12121a)",
                color: "var(--oc-text, #ececf1)",
            },
            "h1, h2, h3, h4, h5, h6": {
                fontFamily: "'Dala Floda', serif",
            },
        }}
    />
);

export default GlobalStylesComponent;
